import React from 'react';

import styled from '@emotion/styled';
import { Button, Input, typographyStyle } from '@revenuemarket/cds';
import { colors } from '@revenuemarket/design';
import { Typography } from 'antd';

import { useConversation } from '~hooks/prompt/useConversation';

interface ChatInterfaceProps {
  conversationId: string | undefined;
  companyId?: string;
}

export default function ChatInterface({ conversationId, companyId }: ChatInterfaceProps) {
  const { prompt, output, isLoading, setPrompt, handleSubmit, handleKeyPress } = useConversation(
    conversationId,
    companyId,
  );

  return (
    <ChatContent>
      <InputContainer>
        <Input
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="AI에게 질문하세요..."
          style={{ flex: 1 }}
          disabled={isLoading || conversationId === undefined}
        />
        <Button
          onClick={handleSubmit}
          loading={isLoading}
          disabled={isLoading || !prompt.trim() || conversationId === undefined}
        >
          전송
        </Button>
      </InputContainer>

      <OutputContainer>
        <Typography.Text style={typographyStyle['16_400']}>
          {!conversationId ? '대화를 시작하는 중...' : output || 'AI 응답이 여기에 표시됩니다...'}
        </Typography.Text>
      </OutputContainer>
    </ChatContent>
  );
}

const ChatContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px;
  overflow: hidden;
`;

const InputContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
`;

const OutputContainer = styled.div`
  flex: 1;
  padding: 12px;
  border: 1px solid ${colors.grayscale200};
  border-radius: 4px;
  background: ${colors.grayscale50};
  overflow-y: auto;
  margin-bottom: 16px;
  white-space: pre-wrap;
`;
